import { createApp } from 'vue'
import App from './App.vue'

import vuetifyInstance from "./plugins/vuetify.js";
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";

import i18n from "./i18n";
import { loadFonts } from "./plugins/webfontloader";
import { router } from "./routes/router";
import { LoadingPlugin } from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import VueDaumPostcode from 'vue-daum-postcode'


loadFonts();

export const app = createApp(App);
app.use(i18n);
app.use(router);
app.use(vuetifyInstance);
app.use(VueSweetalert2);
app.use(LoadingPlugin);
app.use(VueDaumPostcode);
app.mount("#app");
